export default __webpack_public_path__ + "static/media/icon_date_red.3c351c02.svg";